import { computed } from "vue";

export default {
  name: "Loader",
  props: {
    height: {
      type: String,
      default: "16px",
    },
    width: {
      type: String,
      default: "16px",
    },
    borderRadius: {
      type: String,
      default: "4px",
    },
  },
  setup(props) {
    const style = computed(() => ({
      height: props.height,
      width: props.width,
      borderRadius: props.borderRadius,
    }));

    return { 
      style 
    };
  },
};
